<!-- Default action -->
<button app-button buttonSize="xsmall" *ngIf="count === 0" (click)="handleSelectAll()">
  Select All Structures  
</button>

<!-- Checked node actions -->
<button app-button buttonSize="xsmall" *ngIf="count > 0" [matMenuTriggerFor]="checkAllMenu">
  {{ count | number }} <span *ngIf="count === 1">structure</span><span *ngIf="count > 1">structures</span> selected <fa-icon icon="caret-down"></fa-icon>
</button>

<mat-menu #checkAllMenu="matMenu">
  <button mat-menu-item [matMenuTriggerFor]="selectActions">Select</button>
  <button mat-menu-item [matMenuTriggerFor]="showHideActions">Show / Hide</button>
  <button *appFlagInternal mat-menu-item [matMenuTriggerFor]="pickableActions">Pickable / Unpickable</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="handleClearSelection()">Clear Selection</button>
</mat-menu>

<!-- Select submenu -->
<mat-menu #selectActions="matMenu">
  <button mat-menu-item (click)="handleSelectInverse()">Select Everything Else</button>
</mat-menu>

<!-- Show / Hide submenu -->
<mat-menu #showHideActions="matMenu">
  <button mat-menu-item (click)="handleBulkShow()">Show Selected</button>
  <button mat-menu-item (click)="handleBulkHide()">Hide Selected</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="handleHideInverse()">Hide Everything Else</button>
</mat-menu>

<!-- Pickable submenu -->
<mat-menu #pickableActions="matMenu">
  <button mat-menu-item (click)="handleBulkPickable(true)">Make Selected Pickable</button>
  <button mat-menu-item (click)="handleBulkPickable(false)">Make Selected Unpickable</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="handleBulkInversePickable(false)">Make Everything Else Unpickable</button>
</mat-menu>
